// extracted by mini-css-extract-plugin
module.exports = {"phone":"_02712f2b3b--phone--N7aOb"};